import { QuickLinkFormValues } from "../components/QuickLinkForm/QuickLinkForm";

export function formValuesToQuickLink(
	data: QuickLinkFormValues,
	id?: number
): Partial<QuickLink> {
	return {
		...(id !== undefined && { id }),
		heading: data.heading,
		content: data.content || null,
		buttonLink: data.buttonLink || null,
		webview: data.buttonLink ? data.webview : false,
		modalLink: null
	};
}
